// Version : 0.0.1
// Author : VIGNESH
// LastEdit : VIGNESH
// Last ADD : REMOVED UNWANTED REDUX AND ADDED COMMENTS
// MODFIED DATA : 07-12-2025

import { takeLatest, put, all, call } from 'redux-saga/effects';
import AccountDayBookReportActionTypes from './day-book-report.types';
import { dayBookReportGet } from './day-book-report.service';
import {
	fetchDayBookReportFailure,
	fetchDayBookReportSuccess,
	fetchDayBookReportResponseChanged,
} from './day-book-report.action';
import { encryptData } from '../../_common/enode-decode';

import AlertManager from '../../../utils/alertManager';
/************************  START GET MONTHLY PROGRESS DETAILS  **********************/
export function* fetchAccountDayBookReport({ payload }: any) {
	try {
		const key = 'FetchBranchAccountDetailsKey';
		const {
			entryDate,
			fromDate,
			toDate,
			accountHeadID,
			infogCompanyID,
			accountType,
			companyID,
			databaseName,
			searchbyDateType,
			branchID,
			ViewUser,
			userAccessBranchID,
			type,
		} = payload;
		const jsonData = {
			EntryDate: entryDate,
			FromDate: fromDate,
			ToDate: toDate,
			AccountHeadID: accountHeadID,
			Infog_CompanyID: infogCompanyID,
			AccountType: accountType,
			CompanyID: companyID,
			DatabaseName: databaseName,
			SearchbyDateType: searchbyDateType,
			BranchID: branchID,
			ViewUser: ViewUser,
			UserAccessBranchID: userAccessBranchID,
			Type: type,
		};

		const encodeData = encryptData(jsonData, key);
		// @ts-ignore
		const responseData = yield call(dayBookReportGet, encodeData);

		// Check for 401 token validation error
		if (responseData.data.statusCode === '401') {
			// Show token validation alert
			AlertManager.showTokenValidationAlert();
			return;
		} else if (responseData.data.statusCode === '100') {
			yield put(fetchDayBookReportFailure(responseData.data));
		} else {
			yield put(fetchDayBookReportSuccess(responseData.data));
		}
	} catch (error) {
		yield put(fetchDayBookReportFailure(error));
	}
}

export function* resetFetchAccountDayBookReportListResponse() {
	yield put(fetchDayBookReportResponseChanged());
}

export function* onFetchAccountDayBookReportDetails() {
	yield takeLatest(
		AccountDayBookReportActionTypes.FETCH_DAY_BOOK_REPORT_START,
		fetchAccountDayBookReport,
	);
}

export function* onFetchAccountDayBookReportResponseReset() {
	yield takeLatest(
		AccountDayBookReportActionTypes.FETCH_DAY_BOOK_REPORT_RESPONSE_RESET,
		resetFetchAccountDayBookReportListResponse,
	);
}
/***********************  END GET MONTHLY PROGRESS LIST **********************/

export function* accountDayBookReportSaga() {
	yield all([
		call(onFetchAccountDayBookReportDetails),
		call(onFetchAccountDayBookReportResponseReset),
	]);
}
